var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{attrs:{"name":"myPostTour","steps":_vm.tour_steps,"options":_vm.tour_options}})
}
var staticRenderFns = []

export { render, staticRenderFns }